export enum PeopleConnectionStatus {
  CREATED = "created",
  APPROVED = "approved",
  DECLINED = "declined",
}

export enum ConnectionFeedback {
  YES = "YES",
  NO = "NO",
  SCHEDULED = "SCHEDULED",
}

export interface PeopleConnectionItem {
  id: string;
  name: string;
  email: string;
  status: PeopleConnectionStatus;
  feedback: Array<{
    value: ConnectionFeedback;
    timestamp: string;
  }>;
  checkInSentAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PeopleConnectionListResponse {
  data: PeopleConnectionItem[];
  meta: {
    code: number;
  };
}
